import React from 'react';
import {  useNavigate } from "react-router-dom";
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import customizationTheme from '../themes';
import Routes from '../routes/index';
// import OktaAuth, { toRelativeUrl } from "@okta/okta-auth-js";
// import { Security } from "@okta/okta-react";
// import {issuerUrl,oktaClientID} from "../config";


// const oktaAuth = new OktaAuth({
//   issuer:issuerUrl,
//   clientId: oktaClientID,
//   redirectUri: window.location.origin + '/login/callback',
//   scopes: ['openid', 'profile', 'email','config-group']
// })


const App = () => {

  // let navigate = useNavigate();
  // const restoreOriginalUri = (_oktaAuth,  originalUri) => {
  //   navigate(toRelativeUrl(originalUri || '/', window.location.origin));
  // };

  return (
    <>
      {
          <StyledEngineProvider injectFirst>
            <ThemeProvider theme={customizationTheme()}>
              <CssBaseline />
              {/* <Security oktaAuth = {oktaAuth} restoreOriginalUri={restoreOriginalUri}> */}
                <Routes />
              {/* </Security> */}
            </ThemeProvider>
          </StyledEngineProvider>
      }
    </>
  );
};

export default App;
